"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('rinca.core.notify', [])
    .service('notify', ['$timeout', function ($timeout) {
        function NotifyService() {
            var idCounter = 0;
            var ttls = {
                info: 4000,
                success: 3000,
                error: 5000,
                warning: 4000
            };
            this.messages = [];
            this.pop = function (id) {
                var self = this;
                _.remove(self.messages, { id: id });
            };
            this.addMessage = function (type, title, text, ttl) {
                var self = this;
                if (ttl == null) {
                    ttl = ttls[type];
                }
                var id = idCounter++;
                this.messages.push({ type: type, msg: text, title: title, id: id });
                if (ttl) {
                    $timeout(function () {
                        self.pop(id);
                    }, ttl);
                }
            };
            angular.forEach(['info', 'success', 'error', 'warning'], function (type) {
                var self = this;
                this[type] = function (title, text, ttl) {
                    self.addMessage(type, title, text, ttl);
                };
            }, this);
        }
        return new NotifyService();
    }]);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/services/notify.js
// module id = 291
// module chunks = 0